'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _htmlAttributes = require('./htmlAttributes');

var _htmlAttributes2 = _interopRequireDefault(_htmlAttributes);

var _checkAttr = require('./checkAttr');

var _checkAttr2 = _interopRequireDefault(_checkAttr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign, no-restricted-syntax */

var domProps = Object.keys(_htmlAttributes2.default).reduce(function (acc, elem) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _htmlAttributes2.default[elem][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var attr = _step.value;
      acc[attr] = true;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return acc;
}, {});

exports.default = function (attr) {
  return (0, _checkAttr2.default)(domProps, attr);
};